<template>
  <section class="page-section bg-white" id="about">
    <div class="container">
      <div class="text-center">
        <h2 class="section-heading text-uppercase">Nosotros</h2>
        <h3 class="section-subheading text-muted">
          Conoce más sobre Piñatas May
        </h3>
      </div>
      <ul class="timeline">
        <li>
          <div class="timeline-image">
            <a href="#showVideo" title="Piñatas May Jiutepec" data-bs-toggle="modal" data-bs-target="#showVideo">
              <img loading="lazy" class="rounded-circle img-fluid"
                src="@/assets/img/Logo-piñata-May-Dale-dale-a-la-diversión.png" alt="Piñatas May" />
            </a>
          </div>
          <div class="timeline-panel">
            <div class="timeline-heading">
              <h4>Acerca de Piñatas May</h4>
            </div>
            <div class="timeline-body">
              <p class="text-muted">
                En Piñatas May, nos apasiona crear momentos de alegría y
                celebración. Somos una piñateria familiar mexicana con una
                larga tradición en la elaboración de piñatas artesanales.
                Cada una de nuestras piñatas está hecha con amor y
                dedicación, utilizando materiales de alta calidad y diseños
                únicos que harán de tu fiesta un evento inolvidable.
              </p>
            </div>
          </div>
        </li>
        <li class="timeline-inverted">
          <div class="timeline-panel">
            <div class="timeline-heading">
              <h4><RouterLink to="/venta-de-pinatas-en-jiutepec#page-top" 
                title="Venta de Piñatas en Jiutepec"
                class="text-danger"><span class="fa fa-map-marker"></span>
              </RouterLink> Cómo llegar y visitar</h4>
            </div>
            <div class="timeline-body">
              <iframe src="https://storage.googleapis.com/maps-solutions-8mtayc4i7s/locator-plus/u125/locator-plus.html?lang=es"
                width="100%" height="100%" style="border:0;min-height: 375px;"
                title="Venta de Piñatas en Jiutepec"
                 loading="lazy">
              </iframe>
            </div>
          </div>
          <div class="timeline-image">
            <h4 class="mt-5-lg pt-3">
              <a class="text-success" href="tel:5217772408608" id="call"><i class="fas fa-phone-alt me-1"
                  aria-label="Realizar pedido por teléfono"></i>Llámanos</a>
            </h4>
          </div>          
        </li>
      </ul>
    </div>
  </section>
</template>